import axios from 'axios-instance';
import config from 'config';
import { StickerModel } from './models/sticker.model';

const BASE = 'api/TelegramWebApp/stickers';

export default class StickersService {
    static async getAll(initData: string): Promise<StickerModel[]> {
        const { data } = await axios.get<StickerModel[]>(BASE, {
            params: { initData },
        });
        return data;
    }

    static async getPopularTags(initData: string): Promise<string[]> {
        const { data } = await axios.get<string[]>(`${BASE}/tags/popular`, {
            params: { initData },
        });
        return data;
    }

    static async updateTags(id: number, initData: string, tags: string[]): Promise<void> {
        await axios.put(`${BASE}/${id}/tags`, { initData, tags });
    }

    static async delete(id: number, initData: string): Promise<void> {
        await axios.delete(`${BASE}/${id}`, { params: { initData } });
    }

    static thumbnailUrl(id: number, initData: string): string {
        const encoded = encodeURIComponent(initData);
        return `${config.baseUrl}/${BASE}/${id}/thumbnail?initData=${encoded}`;
    }
}
